/**
 * EF.Collections.ActivitiesCollection
 * Collection for holding and finding the activities
 */
(function(EF, undefined) {

  var ActivitiesCollection = Chaplin.Collection.extend({
    model: EF.Models.Activity,

    modelId: function(attrs) { 
      return attrs.key; 
    },

    comparator: 'index',

    initialize: function(attrs, options) {
      this.module = options.module;
    },

    // # getByKey
    //
    // returns Activity by key
    getActivityByKey: function(key) {
      return this.find(function(activity) {
        return activity.get('key') === key;
      });
    },

    completed: function() {
      return this.filter(function(a) {
        return a.get('completed');
      });
    },

    back: function(activity) {
      var idx = activity.get('index');
      var models = this.toArray().reverse();
      var model = _.find(models, function(a) {
        return a.get('index') < idx;
      });
      if(model) {
        return model;
      }
      else {
        return false;
      }
    }
  });

  _.extend(EF.Collections, {
    ActivitiesCollection: ActivitiesCollection
  });

})(EF);
